import { getLowestServicePrice, getPublicServices } from "utils/helpers/psychologistUtil"
import { OfferedService } from "utils/interfaces"

export function getProperServicePrice(
    basicServices: OfferedService[],
    services?: OfferedService[],
    singleServicePrice?: number
) {
    if (services !== undefined && services?.length > 0) {
        return getLowestServicePrice(getPublicServices(services))
    } else if (singleServicePrice !== undefined) {
        return singleServicePrice
    }

    return getLowestServicePrice(getPublicServices(basicServices))
}
